import AuthenticationMethod, { AuthenticationMethodType } from './AuthenticationMethod';

export default AuthenticationMethod;

export { AuthenticationMethodType };
